import React from 'react';

const ComingSoonPage = ({ pageTitle = "Content" }) => {
    const containerStyle = {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f9fafb',
        fontFamily: 'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif'
    };

    const contentStyle = {
        textAlign: 'center',
        padding: '2rem',
        maxWidth: '42rem',
        margin: '0 auto'
    };

    const titleStyle = {
        fontSize: '2rem',
        fontWeight: '800',
        color: '#969696ff',
        marginBottom: '1.5rem',
        letterSpacing: '-0.025em'
    };

    const descriptionStyle = {
        fontSize: '1.125rem',
        color: '#5c6066ff',
        fontWeight: '300',
        lineHeight: '1.6',
        marginTop: '1rem'
    };

    const ComingSoonContent = () => (
        <div style={contentStyle}>
            <h1 style={titleStyle}>
                Coming Soon...
            </h1>
            <p style={descriptionStyle}>
                <strong>{pageTitle}</strong> Page will be available soon!
            </p>
        </div>
    );

    return (
        <div style={containerStyle}>
            <ComingSoonContent />
        </div>
    );
};

export default ComingSoonPage;